module.exports = __webpack_public_path__ + "static/media/football-carousel-2-480x320.33651671.jpg";